"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tags = exports.TsRecordType = exports.SummaryTimestampLabelType = exports.QoS = exports.BlendingCompleteArgs = exports.BlendingRetryArgs = void 0;
class BlendingRetryArgs {
    constructor(obj) {
        if (obj) {
            this.timestamp = obj.timestamp;
            this.rtl = obj.rtl;
        }
    }
}
exports.BlendingRetryArgs = BlendingRetryArgs;
class BlendingCompleteArgs {
    constructor(obj) {
        if (obj) {
            this.tsRecords = obj.tsRecords;
        }
    }
}
exports.BlendingCompleteArgs = BlendingCompleteArgs;
var QoS;
(function (QoS) {
    QoS[QoS["Realtime"] = 0] = "Realtime";
    QoS[QoS["Delayed"] = 1] = "Delayed";
    QoS[QoS["Unknown"] = 2] = "Unknown";
})(QoS || (exports.QoS = QoS = {}));
var SummaryTimestampLabelType;
(function (SummaryTimestampLabelType) {
    SummaryTimestampLabelType[SummaryTimestampLabelType["StartPeriod"] = 0] = "StartPeriod";
    SummaryTimestampLabelType[SummaryTimestampLabelType["EndPeriod"] = 1] = "EndPeriod";
})(SummaryTimestampLabelType || (exports.SummaryTimestampLabelType = SummaryTimestampLabelType = {}));
var TsRecordType;
(function (TsRecordType) {
    TsRecordType[TsRecordType["Tas"] = 1] = "Tas";
    TsRecordType[TsRecordType["Taq"] = 2] = "Taq";
    TsRecordType[TsRecordType["Correction"] = 4] = "Correction";
    TsRecordType[TsRecordType["Summary"] = 8] = "Summary";
})(TsRecordType || (exports.TsRecordType = TsRecordType = {}));
var Tags;
(function (Tags) {
    Tags["CONFIGURATION"] = "Cfg";
    Tags["GLOBAL_METADATA"] = "Gmd";
    Tags["METADATA"] = "Md";
    Tags["VIEWLIST"] = "Vl";
    Tags["HISTORICAL"] = "His";
    Tags["PARTIALBAR"] = "Pbr";
    Tags["STREAMING"] = "Ste";
    Tags["STREAMING_API"] = "SteA";
    Tags["LOGICIZING"] = "Lgc";
    Tags["RULE_ENGINE"] = "Ren";
    Tags["SUMMARIZING"] = "Sum";
    Tags["BLENDING"] = "Bln";
    Tags["CLIENT_SERVICE"] = "Cs";
    Tags["REQUEST_QUEUE"] = "Rq";
    Tags["TRADING_SESSION"] = "Tds";
})(Tags || (exports.Tags = Tags = {}));
